<template>
  <div
    v-loading="loading"
    :element-loading-text="$t('commonInfo.Loading')"
    class="main-frame"
  >
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="12">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                :content="$t('scratchCode.editScratchCodeDetail')"
              ></el-page-header>
            </el-col>

            <el-col style="text-align: right" :span="12">
              <!-- <el-button @click="save_model_info('form')" type="primary">{{
                $t("editStoreDetail.Save")
              }}</el-button> -->
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <el-form
          ref="form"
          :rules="rules"
          class="edit_module"
          :inline="true"
          :model="form"
        >
          <el-form-item :label="$t('scratchCode.checkTime')">
            <el-input
              disabled
              v-model.trim="form.checked_times"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('scratchCode.scratchCode')">
            <el-input
              disabled
              v-model.trim="form.scratch_code"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "AddStoreInfo",
  data() {
    return {
      loading: false,
      form: {
        checked_times: "",
        scratch_code: "",
      },
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    // 编辑门店信息并保存
    save_model_info(form) {
      this.loading = true;
      let _me = this;
      _me.form.contact_information_list.forEach((item, index) => {
        item.id = item.id;
        item.store_id = item.store_id;
      });
      _me.add_contact_form.contact_information_list_clone =
        this.$common.deepClone(this.add_contact_form.contact_information_list);
      let params = {
        id: _me.$route.query.id,
        country_id: _me.form.country_id,
        province_id: _me.form.province_id,
        city_id: _me.form.city_id,
        company_name: _me.form.company_name,
        retail_area_type_id: _me.form.retail_area_type_id,
        address: _me.form.address,
        contact_information_list: JSON.stringify(
          _me.add_contact_form.contact_information_list_clone
        ),
        address: _me.form.address,
        area_size: Number(_me.form.area_size),
        turnover: Number(_me.form.turnover),
        smok_turnover: Number(_me.form.smok_turnover),
        zip: _me.form.zip,
      };
      // 验证通过才发起请求
      _me.$refs[form].validate((valid) => {
        if (valid) {
          _me.$common
            .httpPost("/api/store/admin/update/one", params)
            .then((res) => {
              _me.loading = false;
              if (res.code == 1000000) {
                _me.$message.success(this.$t("editStoreDetail.EditSuccess"));
                _me.$router.go(-1);
              } else {
                _me.$message.error(res.message);
              }
            })
            .catch((err) => {
              _me.loading = false;
              if (err.code == 1000009 || err.code == 1000007) {
                _me.$router.push("sign-in");
              }
              _me.$message.error(err.message);
            });
        }
      });
    },
    // 获取单项刮刮码全部数据
    get_scratch_code_item_info(id) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: id,
      };
      this.$common
        .httpPost("/api/scratch/admin/code/find/id", params)
        .then((res) => {
          _me.loading = false;
          if (res.code == "1000000") {
            Object.assign(_me.form, res.data);
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err);
        });
    },
  },
  created() {},
  mounted() {
    // 获取单个门店的基本数据
    let pre_item_id = this.$route.query.id;
    if (pre_item_id) {
      this.get_scratch_code_item_info(pre_item_id);
    }
  },
};
</script>

<style scoped>
.banner-head {
  /*background-color: white;*/
  background-color: #f1f1f1;
  height: 60px;
}

.head-info {
  color: #ffffff;
}

main > form.edit_module {
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0;
  /* justify-content: center; */
  /* justify-content: space-between; */
}
main > form.edit_module > div {
  /* margin: 20px 0; */
  width: 25%;
  text-align: right;
  margin: 20px;
  /* display: flex; */
  /* justify-content: space-around; */
  /* align-items: right; */
  /* flex-direction: column; */
}
</style>
